export default "__VITE_ASSET__c9c2e359__"